<script lang="ts">
	import { _ } from 'svelte-i18n';
	import { page } from '$app/stores';
	import FastBtn from '$lib/component/fast-btn.svelte';
	import Footer from '$lib/component/footer.svelte';
	import Navbar from '$lib/component/navbar.svelte';
	import Partner from '$lib/component/partner.svelte';
	import { initHeroHomeSwiper } from '$lib/js/script.js';
	import { onMount } from 'svelte';

	import type { PageServerData } from './$types';
	export let data: PageServerData;

	const lang = $page.params.locale;

	let partner = data?.partner;
	let offer = data?.offer;
	let award = data?.award;

	onMount(() => {
		initHeroHomeSwiper();

		const script = document.createElement('script');
		script.src = 'https://unpkg.com/@phosphor-icons/web';
		script.async = true;
		document.head.appendChild(script);
	});
</script>

<svelte:head>
	<title>{offer.name} - Holiday Inn Resort Bali Nusa Dua</title>
	<link rel="canonical" href="http://50.6.171.246:5000/offer/{offer.slug}" />
</svelte:head>

<Navbar />

<FastBtn />

<section id="rooms">
	<div id="hero-banner" class="container-fluid p-0">
		<div class="w-100 h-100 p-md-0 p-0 position-relative overflow-hidden">
			<img
				alt="Holiday Inn Resorts Nusa Dua"
				src={offer.featured_images[0].path}
				class="img-header"
			/>
			<div id="hero-text" class="position-absolute top-0 start-0 w-100 h-100">
				<div class="row g-0 w-100 h-100 justify-content-center align-items-center">
					<div class="col-md-6 text-center text-white p-3">
						<p class="ff-lola-mr fs-4 mb-2 fw-light">Special Offers</p>
						<h1 class="ff-lola-bir display-3 mb-3">{offer.name}</h1>
					</div>
				</div>
			</div>
		</div>
	</div>

	<div class="container-fluid py-md-5 py-5 px-0">
		<div class="container px-md-0 px-3">
			<div class="row g-0 justify-content-center align-items-start mb-md-5 mb-5">
				<div class="col-md-10 pe-md-5">
					<p class="mb-md-3 main-color display-5 pe-md-3 ff-lola-bir lh-2">{offer.name}</p>
					<p class="line mb-md-4 mb-3"></p>
					<div class="ff-helvetica">{@html offer.description}</div>
					{#if offer.terms != ''}
						<div class="accordion my-4 my-md-4" id="accordionExample">
							<div class="accordion-item">
								<h2 class="accordion-header">
									<button
										class="accordion-button ff-lola-bir fs-5"
										type="button"
										data-bs-toggle="collapse"
										data-bs-target="#collapseOne"
										aria-expanded="true"
										aria-controls="collapseOne"
									>
										Terms & Conditions
									</button>
								</h2>
								<div
									id="collapseOne"
									class="accordion-collapse collapse show"
									data-bs-parent="#accordionExample"
								>
									<div class="accordion-body">
										{@html offer.terms}
									</div>
								</div>
							</div>
						</div>
					{/if}
					<p>
						<a
							data-sveltekit-reload
							href={offer.book_url}
							target="_blank"
							class="btn main-btn text-uppercase ff-lola-mr px-4 py-2">{$_('btn_book')}</a
						>
					</p>
				</div>
			</div>
		</div>
	</div>
</section>

<Partner {partner} />

<Footer {award} />

<style>
	#hero-text {
		background-color: rgba(0, 0, 0, 0.3);
	}
	.rooms-welcome::before {
		content: '';
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100vh;
		z-index: -1;
		margin-bottom: -2px;
		background-image: linear-gradient(
				to top,
				rgba(255, 255, 255, 1),
				rgba(255, 255, 255, 0.85),
				rgba(255, 255, 255, 0.8)
			),
			url('/img/bg-home-1.jpg');
		background-position: center;
		background-size: cover;
	}
	.line {
		border-bottom: 2px solid #757fbd;
		width: 25%;
	}
	.line-2 {
		border-bottom: 2px solid #757fbd;
		width: 15%;
	}
	.ratio-21x7 {
		aspect-ratio: 21/7;
	}
	.slider-img-room .nav-slider-img-room .btn-prev,
	.slider-img-room .nav-slider-img-room .btn-next {
		width: 50px;
		height: 50px;
		border-radius: 10px;
		border: 2px solid white;
		color: white;
		font-size: 26px;
		cursor: pointer;
		transition: 0.3s all;
	}
	.slider-img-room .nav-slider-img-room .btn-prev:hover,
	.slider-img-room .nav-slider-img-room .btn-next:hover {
		background-color: rgba(255, 255, 255, 0.3);
		transition: 0.3s all;
	}

	.nav-slider-room .btn-prev,
	.nav-slider-room .btn-next {
		border: 1px solid #757fbd;
		color: #757fbd;
		width: 50px;
		height: 50px;
		font-size: 24px;
		transition: 0.3s all;
	}
	.nav-slider-room .btn-prev:hover,
	.nav-slider-room .btn-next:hover {
		border: 1px solid #757fbd;
		background-color: #757fbd;
		color: white;
		transition: 0.3s all;
	}

	.slider-other-room .swiper-slide-active {
		transition: margin-left 0.3s ease; /* Tambahkan animasi jika diperlukan */
	}

	.rooms-amenities .icon {
		background-color: #e6e9f8;
		color: #757fbd;
		border-radius: 100%;
		width: 40px;
		height: 40px;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	@media (max-width: 600px) {
		.rooms-welcome .right-content-rooms:before {
			content: unset;
		}
		.rooms-welcome .slider-img-room .ratio-21x9 {
			aspect-ratio: 9/7 !important;
		}
		.ratio-21x7 {
			aspect-ratio: 1/1;
		}
	}
</style>
